/**
 * Invite flow input schemas.
 *
 * Builds on the `invitations` table schema declared in beta.ts. These schemas
 * cover bulk create + resend endpoints added in Phase 7 Wave 2, plus the
 * team_ids extension from migration 0015.
 */

import { z } from 'zod';
import {
  InvitationCreateInputSchema,
  InvitationPublicSchema,
  InvitationRoleSchema,
  InvitationTokenSchema,
} from './beta';
import { EmailSchema, UuidSchema } from './primitives';

export const InviteWithTeamsCreateInputSchema = InvitationCreateInputSchema.extend({
  team_ids: z.array(UuidSchema).max(20).default([]),
});
export type InviteWithTeamsCreateInput = z.input<typeof InviteWithTeamsCreateInputSchema>;

export const InviteBulkCreateInputSchema = z.object({
  invites: z
    .array(
      z.object({
        email: EmailSchema.transform((e) => e.toLowerCase()),
        role: InvitationRoleSchema.default('member'),
        team_ids: z.array(UuidSchema).max(20).default([]),
      }),
    )
    .min(1)
    .max(50),
});
export type InviteBulkCreateInput = z.input<typeof InviteBulkCreateInputSchema>;

export const InviteBulkCreateResponseSchema = z.object({
  created: z.array(InvitationPublicSchema),
  failed: z.array(
    z.object({
      email: z.string(),
      reason: z.string(),
    }),
  ),
});
export type InviteBulkCreateResponse = z.infer<typeof InviteBulkCreateResponseSchema>;

export const InviteResendInputSchema = z.object({
  id: UuidSchema,
});
export type InviteResendInput = z.infer<typeof InviteResendInputSchema>;

export const InviteResendResponseSchema = z.object({
  invitation: InvitationPublicSchema,
  email_queue_id: UuidSchema,
});
export type InviteResendResponse = z.infer<typeof InviteResendResponseSchema>;

export { InvitationTokenSchema };
